"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageInstanceCardToJSON = exports.PackageInstanceCardFromJSONTyped = exports.PackageInstanceCardFromJSON = exports.instanceOfPackageInstanceCard = exports.PackageInstanceCardFrequencyEnum = exports.PackageInstanceCardPackageTypeEnum = exports.PackageInstanceCardTimeTypeEnum = exports.PackageInstanceCardContentTypeEnum = exports.PackageInstanceCardStatusEnum = void 0;
const runtime_1 = require("../runtime");
const OnTrackHistory_1 = require("./OnTrackHistory");
const OnTrackNotifications_1 = require("./OnTrackNotifications");
const OnTrackRules_1 = require("./OnTrackRules");
const OnTrackStatus_1 = require("./OnTrackStatus");
const PackageInstanceCardCyclesInner_1 = require("./PackageInstanceCardCyclesInner");
const PackageInstanceCardOrganizationSettings_1 = require("./PackageInstanceCardOrganizationSettings");
const PackageInstanceItem_1 = require("./PackageInstanceItem");
const PackageInstancePayment_1 = require("./PackageInstancePayment");
const UsagePackageInvoicing_1 = require("./UsagePackageInvoicing");
/**
* @export
* @enum {string}
*/
var PackageInstanceCardStatusEnum;
(function (PackageInstanceCardStatusEnum) {
    PackageInstanceCardStatusEnum["Active"] = "active";
    PackageInstanceCardStatusEnum["Completed"] = "completed";
    PackageInstanceCardStatusEnum["Scheduled"] = "scheduled";
    PackageInstanceCardStatusEnum["Deleted"] = "deleted";
    PackageInstanceCardStatusEnum["Paused"] = "paused";
    PackageInstanceCardStatusEnum["Ordered"] = "ordered";
    PackageInstanceCardStatusEnum["Processing"] = "processing";
    PackageInstanceCardStatusEnum["Blocked"] = "blocked";
})(PackageInstanceCardStatusEnum || (exports.PackageInstanceCardStatusEnum = PackageInstanceCardStatusEnum = {}));
/**
* @export
* @enum {string}
*/
var PackageInstanceCardContentTypeEnum;
(function (PackageInstanceCardContentTypeEnum) {
    PackageInstanceCardContentTypeEnum["Sessions"] = "sessions";
    PackageInstanceCardContentTypeEnum["Time"] = "time";
})(PackageInstanceCardContentTypeEnum || (exports.PackageInstanceCardContentTypeEnum = PackageInstanceCardContentTypeEnum = {}));
/**
* @export
* @enum {string}
*/
var PackageInstanceCardTimeTypeEnum;
(function (PackageInstanceCardTimeTypeEnum) {
    PackageInstanceCardTimeTypeEnum["Minutes"] = "minutes";
    PackageInstanceCardTimeTypeEnum["Hours"] = "hours";
})(PackageInstanceCardTimeTypeEnum || (exports.PackageInstanceCardTimeTypeEnum = PackageInstanceCardTimeTypeEnum = {}));
/**
* @export
* @enum {string}
*/
var PackageInstanceCardPackageTypeEnum;
(function (PackageInstanceCardPackageTypeEnum) {
    PackageInstanceCardPackageTypeEnum["OneTime"] = "one-time";
    PackageInstanceCardPackageTypeEnum["Recurring"] = "recurring";
    PackageInstanceCardPackageTypeEnum["Usage"] = "usage";
    PackageInstanceCardPackageTypeEnum["Flexible"] = "flexible";
    PackageInstanceCardPackageTypeEnum["Subscription"] = "subscription";
})(PackageInstanceCardPackageTypeEnum || (exports.PackageInstanceCardPackageTypeEnum = PackageInstanceCardPackageTypeEnum = {}));
/**
* @export
* @enum {string}
*/
var PackageInstanceCardFrequencyEnum;
(function (PackageInstanceCardFrequencyEnum) {
    PackageInstanceCardFrequencyEnum["Months"] = "months";
    PackageInstanceCardFrequencyEnum["Weeks"] = "weeks";
    PackageInstanceCardFrequencyEnum["Years"] = "years";
})(PackageInstanceCardFrequencyEnum || (exports.PackageInstanceCardFrequencyEnum = PackageInstanceCardFrequencyEnum = {}));
/**
 * Check if a given object implements the PackageInstanceCard interface.
 */
function instanceOfPackageInstanceCard(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "totalBooked" in value;
    isInstance = isInstance && "totalAccrued" in value;
    isInstance = isInstance && "totalAvailable" in value;
    isInstance = isInstance && "totalCompleted" in value;
    isInstance = isInstance && "totalBookedFromUnlimitedSchedulers" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "packageId" in value;
    isInstance = isInstance && "clientId" in value;
    return isInstance;
}
exports.instanceOfPackageInstanceCard = instanceOfPackageInstanceCard;
function PackageInstanceCardFromJSON(json) {
    return PackageInstanceCardFromJSONTyped(json, false);
}
exports.PackageInstanceCardFromJSON = PackageInstanceCardFromJSON;
function PackageInstanceCardFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'internalName': !(0, runtime_1.exists)(json, 'internalName') ? undefined : json['internalName'],
        'icon': !(0, runtime_1.exists)(json, 'icon') ? undefined : json['icon'],
        'status': json['status'],
        'totalBooked': json['totalBooked'],
        'totalAccrued': json['totalAccrued'],
        'totalAvailable': json['totalAvailable'],
        'totalCompleted': json['totalCompleted'],
        'totalBookedFromUnlimitedSchedulers': json['totalBookedFromUnlimitedSchedulers'],
        'contentType': !(0, runtime_1.exists)(json, 'contentType') ? undefined : json['contentType'],
        'timeType': !(0, runtime_1.exists)(json, 'timeType') ? undefined : json['timeType'],
        'packageType': !(0, runtime_1.exists)(json, 'packageType') ? undefined : json['packageType'],
        'frequency': !(0, runtime_1.exists)(json, 'frequency') ? undefined : json['frequency'],
        'cycles': !(0, runtime_1.exists)(json, 'cycles') ? undefined : (json['cycles'].map(PackageInstanceCardCyclesInner_1.PackageInstanceCardCyclesInnerFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'endDate': !(0, runtime_1.exists)(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'startDate': !(0, runtime_1.exists)(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'resetDate': !(0, runtime_1.exists)(json, 'resetDate') ? undefined : (new Date(json['resetDate'])),
        'pausedOn': !(0, runtime_1.exists)(json, 'pausedOn') ? undefined : (new Date(json['pausedOn'])),
        'isRollover': !(0, runtime_1.exists)(json, 'isRollover') ? undefined : json['isRollover'],
        'distributeSessions': !(0, runtime_1.exists)(json, 'distributeSessions') ? undefined : json['distributeSessions'],
        'items': (json['items'].map(PackageInstanceItem_1.PackageInstanceItemFromJSON)),
        'participants': !(0, runtime_1.exists)(json, 'participants') ? undefined : json['participants'],
        'supervisors': !(0, runtime_1.exists)(json, 'supervisors') ? undefined : json['supervisors'],
        'packageId': json['packageId'],
        'clientId': json['clientId'],
        'isLocked': !(0, runtime_1.exists)(json, 'isLocked') ? undefined : json['isLocked'],
        'invoiceId': !(0, runtime_1.exists)(json, 'invoiceId') ? undefined : json['invoiceId'],
        'payments': !(0, runtime_1.exists)(json, 'payments') ? undefined : (json['payments'].map(PackageInstancePayment_1.PackageInstancePaymentFromJSON)),
        'usageInvoicing': !(0, runtime_1.exists)(json, 'usageInvoicing') ? undefined : (0, UsagePackageInvoicing_1.UsagePackageInvoicingFromJSON)(json['usageInvoicing']),
        'onTrackStatus': !(0, runtime_1.exists)(json, 'onTrackStatus') ? undefined : (0, OnTrackStatus_1.OnTrackStatusFromJSON)(json['onTrackStatus']),
        'onTrackHistory': !(0, runtime_1.exists)(json, 'onTrackHistory') ? undefined : (json['onTrackHistory'].map(OnTrackHistory_1.OnTrackHistoryFromJSON)),
        'onTrackRules': !(0, runtime_1.exists)(json, 'onTrackRules') ? undefined : (0, OnTrackRules_1.OnTrackRulesFromJSON)(json['onTrackRules']),
        'onTrackNotifications': !(0, runtime_1.exists)(json, 'onTrackNotifications') ? undefined : (0, OnTrackNotifications_1.OnTrackNotificationsFromJSON)(json['onTrackNotifications']),
        'onTrackEnabled': !(0, runtime_1.exists)(json, 'onTrackEnabled') ? undefined : json['onTrackEnabled'],
        'organizationSettings': !(0, runtime_1.exists)(json, 'organizationSettings') ? undefined : (0, PackageInstanceCardOrganizationSettings_1.PackageInstanceCardOrganizationSettingsFromJSON)(json['organizationSettings']),
        'tierTitle': !(0, runtime_1.exists)(json, 'tierTitle') ? undefined : json['tierTitle'],
        'tierPriceTitle': !(0, runtime_1.exists)(json, 'tierPriceTitle') ? undefined : json['tierPriceTitle'],
        'expiration': !(0, runtime_1.exists)(json, 'expiration') ? undefined : (json['expiration'] === null ? null : new Date(json['expiration'])),
    };
}
exports.PackageInstanceCardFromJSONTyped = PackageInstanceCardFromJSONTyped;
function PackageInstanceCardToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'title': value.title,
        'internalName': value.internalName,
        'icon': value.icon,
        'status': value.status,
        'totalBooked': value.totalBooked,
        'totalAccrued': value.totalAccrued,
        'totalAvailable': value.totalAvailable,
        'totalCompleted': value.totalCompleted,
        'totalBookedFromUnlimitedSchedulers': value.totalBookedFromUnlimitedSchedulers,
        'contentType': value.contentType,
        'timeType': value.timeType,
        'packageType': value.packageType,
        'frequency': value.frequency,
        'cycles': value.cycles === undefined ? undefined : (value.cycles.map(PackageInstanceCardCyclesInner_1.PackageInstanceCardCyclesInnerToJSON)),
        'createdAt': (value.createdAt.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'resetDate': value.resetDate === undefined ? undefined : (value.resetDate.toISOString()),
        'pausedOn': value.pausedOn === undefined ? undefined : (value.pausedOn.toISOString()),
        'isRollover': value.isRollover,
        'distributeSessions': value.distributeSessions,
        'items': (value.items.map(PackageInstanceItem_1.PackageInstanceItemToJSON)),
        'participants': value.participants,
        'supervisors': value.supervisors,
        'packageId': value.packageId,
        'clientId': value.clientId,
        'isLocked': value.isLocked,
        'invoiceId': value.invoiceId,
        'payments': value.payments === undefined ? undefined : (value.payments.map(PackageInstancePayment_1.PackageInstancePaymentToJSON)),
        'usageInvoicing': (0, UsagePackageInvoicing_1.UsagePackageInvoicingToJSON)(value.usageInvoicing),
        'onTrackStatus': (0, OnTrackStatus_1.OnTrackStatusToJSON)(value.onTrackStatus),
        'onTrackHistory': value.onTrackHistory === undefined ? undefined : (value.onTrackHistory.map(OnTrackHistory_1.OnTrackHistoryToJSON)),
        'onTrackRules': (0, OnTrackRules_1.OnTrackRulesToJSON)(value.onTrackRules),
        'onTrackNotifications': (0, OnTrackNotifications_1.OnTrackNotificationsToJSON)(value.onTrackNotifications),
        'onTrackEnabled': value.onTrackEnabled,
        'organizationSettings': (0, PackageInstanceCardOrganizationSettings_1.PackageInstanceCardOrganizationSettingsToJSON)(value.organizationSettings),
        'tierTitle': value.tierTitle,
        'tierPriceTitle': value.tierPriceTitle,
        'expiration': value.expiration === undefined ? undefined : (value.expiration === null ? null : value.expiration.toISOString()),
    };
}
exports.PackageInstanceCardToJSON = PackageInstanceCardToJSON;
//# sourceMappingURL=PackageInstanceCard.js.map